import { Inject, Injectable } from '@angular/core';
import { RouteChangeHandler, RouterStoreService, ROUTE_CHANGE_HANDLER } from '../infrastructure';

@Injectable({ providedIn: 'root' })
export class RouterEventsFacade {
    constructor(
        private readonly routerStoreService: RouterStoreService,
        @Inject(ROUTE_CHANGE_HANDLER) private readonly services: RouteChangeHandler[]
    ) {}

    hookRouterEvents(): void {
        this.routerStoreService.state$.subscribe((state) => {
            this.services.forEach((service) => {
                service.handleRouteChange(state);
            });
        });
    }
}
